module.exports = __webpack_public_path__ + "static/DAWN0-3e889b64bedb72521022588805367ca3.png";